module.exports = __webpack_public_path__ + "img/question_logo.cbd6704d.jpg";